module.exports = __webpack_public_path__ + "img/malaysia.e85838a4.png";